<template>
  <div>
    <transition name="fade-grafico-prestador" mode="out-in">
      <div v-if="!loading">
        <unicom-linha :espacamento="false" style="min-height: 35px">
          <unicom-coluna sm="auto" alinhamento="center" class="mr-3">
            <unicom-icone
              style="color: #00995d"
              nome="pie-chart"
              :tamanho="25"
            />
          </unicom-coluna>
          <unicom-coluna sm="auto" alinhamento="center">
            <div class="negrito fonte-primaria" style="font-size: 21px">
              Tipos de prestadores
            </div>
          </unicom-coluna>
        </unicom-linha>
        <div class="fonte-primaria" style="margin: 0px !important">
          <div id="container">
            <highcharts
              ref="grafico"
              :options="chartOptions"
              :callback="graficoCarregado"
            ></highcharts>
          </div>
        </div>
      </div>
      <div v-else>
        <CarregandoTipoPrestador />
      </div>
    </transition>
  </div>
</template>

<script>
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import CarregandoTipoPrestador from "./CarregandoTipoPrestador";
import GraficoMixin from "../GraficoMixin";

export default {
  components: {
    highcharts: Chart,
    CarregandoTipoPrestador
  },
  mixins: [GraficoMixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    arrayGrafico: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    arrayGrafico: {
      deep: true,
      immediate: true,
      handler() {
        this.atualizarDados();
      }
    }
  },
  methods: {
    atualizarDados() {
      let arrayGraficoOrdenado = this.arrayGrafico.map(e => e);
      arrayGraficoOrdenado.sort(function(a, b) {
        return b.quantidade - a.quantidade;
      });
      const categorias = arrayGraficoOrdenado.map(e => e.tipo.descricao);
      const quantidades = arrayGraficoOrdenado.map(e => ({
        y: e.quantidade,
        chave: e.tipo.chave
      }));

      this.$set(this.chartOptions.xAxis, "categories", categorias);
      this.$set(this.chartOptions.series[0], "data", quantidades);
      this.$nextTick(() => {
        if (this.dadosDesativados) {
          this.reiniciarGrafico();
        }
      });
    },

    reiniciarGrafico() {
      this.ativarTodasColunas();
      this.desativarColunasPorChave(this.chaveSelecionada);
      this.graficoRef.redraw();
    },

    /**
     * Ação de clique das colunas
     * @param { String } chave
     */
    selecionarChave(chave) {
      if (this.chaveSelecionada === chave && this.dadosDesativados) {
        this.$emit("remove-filtro", {
          chaveRemocao: "tipoPrestador",
          sucesso: () => this.ativarColunas()
        });
        return;
      } else if (this.dadosDesativados) {
        return;
      }

      this.$emit("adiciona-filtro", {
        chaveAdicao: "tipoPrestador",
        value: chave,
        sucesso: () => this.desativarColunas(chave)
      });
    },

    /**
     * Desativa todas as colunas menos a que tem a chave igual ao do parâmetro
     * @param { String } chave
     */
    desativarColunas(chave) {
      this.dadosDesativados = true;
      this.chaveSelecionada = chave;

      this.desativarColunasPorChave(chave);
      this.graficoRef.redraw();
    },
    /**
     * Reativa todas as colunas
     */
    ativarColunas() {
      this.chaveSelecionada = null;
      this.dadosDesativados = false;

      this.ativarTodasColunas();
      this.graficoRef.redraw();
    },
    /**
     * Ativa todas as colunas do gráfico
     */
    ativarTodasColunas() {
      this.graficoRef.series[0].data.forEach(e => {
        e.update(
          {
            opacity: 1,
            className: ""
          },
          false
        );
      });
    },
    /**
     * Desativa todas as séries, menos a da chave que é passada
     */
    desativarColunasPorChave(chave) {
      this.graficoRef.series[0].data.forEach(e => {
        const { chave: chaveAtual } = e.options;

        if (chave !== chaveAtual) {
          e.update(
            {
              opacity: 0.4,
              className: "tipo-prestador-desativado"
            },
            false
          );
        }
      });
    }
  },
  data() {
    return {
      graficoRef: null,

      chartOptions: {
        title: {
          text: ""
        },

        credits: {
          enabled: false
        },

        chart: {
          type: "bar"
        },

        xAxis: {
          lineColor: "#DEE2E6",
          categories: [],
          min: 0
        },

        yAxis: {
          gridLineColor: "#DEE2E6",
          lineColor: "#DEE2E6",
          lineWidth: 1,
          startOnTick: true,
          showFirstLabel: false,
          endOnTick: true,
          showLastLabel: true,
          tickInterval: 5000,
          labels: {
            formatter: function() {
              return Highcharts.numberFormat(this.value, 0, ".", ".");
            },
            enabled: true,
            overflow: "justify"
          },
          title: false,
          min: 0
        },

        tooltip: {
          enabled: false
        },

        series: [
          {
            cursor: "pointer",
            showInLegend: false,
            data: [],
            color: "#1DAA7D",
            dataLabels: {
              enabled: true,
              style: {
                fontWeight: "normal",
                fontFamily: "Trebuchet MS",
                textAlign: "center",
                fontSize: "16px",
                color: "#60656C"
              },
              formatter: function() {
                const estaDesativado =
                  this.point.className === "tipo-prestador-desativado";

                return `<div style="${
                  estaDesativado ? "cursor: not-allowed" : ""
                }"> ${Highcharts.numberFormat(this.y, 0, ".", ".")} </div> `;
              },
              useHTML: true
            },
            point: {
              events: {
                click: ev => {
                  const { chave } = ev.point.options;
                  this.selecionarChave(chave);
                }
              }
            },
            states: {
              hover: {
                enabled: true
              }
            }
          }
        ]
      }
    };
  }
};
</script>

<style lang="scss">
.data-label-desativado {
  cursor: not-allowed !important;
  fill: #dee2e6;
}

.tipo-prestador-desativado {
  cursor: not-allowed;
  fill: #dee2e6;
}

.highcharts-legend-item > span {
  top: 0px !important;
}

.fade-grafico-prestador-enter-active,
.fade-grafico-prestador-leave,
.fade-grafico-prestador-leave-to {
  transition: opacity 0.25s ease;
}

.fade-grafico-prestador-enter,
.fade-grafico-prestador-leave-to {
  opacity: 0;
}
</style>
